// extracted by mini-css-extract-plugin
export default {"box":"root_icon-module__box___fPC0z","svg":"root_icon-module__svg___lvKPU"};